export default __webpack_public_path__ + "static/media/logo-dark.b04904d5.svg";